export enum enumTipoPessoa {
    
  Fisica=1,
  Juridica=2,
}